import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BooksConfirmAlert.module.scss';

interface Props {
  className?: string;
  termsUrl: string;
  lawUrl: string;
}

const BooksConfirmAlert = ({
  className,
  intl,
  termsUrl,
  lawUrl,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksConfirmAlert, className);

  return (
    <div className={classes}>
      <p className={`${css.BooksConfirmAlert__Paragraph} ${css.isBold}`}>
        {intl.formatMessage({ id: 'books.forms.confirmAlertMessage1' })}
        <br />
        <span className={css.BooksConfirmAlert__Em}>
          {intl.formatMessage({ id: 'books.forms.confirmAlertMessage2' })}
        </span>
      </p>
      <p className={css.BooksConfirmAlert__Paragraph}>
        <FormattedMessage
          id="books.forms.confirmAlertMessage3"
          values={{
            terms: (
              <Link href={termsUrl} prefetch={false}>
                <a
                  className={css.BooksConfirmAlert__Link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {intl.formatMessage({ id: 'books.forms.termOfUse' })}
                </a>
              </Link>
            ),
            law: (
              <Link href={lawUrl} prefetch={false}>
                <a
                  className={css.BooksConfirmAlert__Link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {intl.formatMessage({
                    id: 'books.forms.specifiedCommercialTransactionsLaw',
                  })}
                </a>
              </Link>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default injectIntl(BooksConfirmAlert);
